/**
 * @file StoreList.js
 * @desc Store list
 * @author YongZhang<zhangyong06@baidu.com>
 */
'use strict';
import Menu from './Menu';
import Industry from './Industry';
import Statistics from './Statistics';
import EventBus from './EventBus';
import Service from './Service';
import lawStore from './law-store';

export default {
    Menu,
    Industry,
    Statistics,
    EventBus,
    Service,
    lawStore
};
